import { toast } from "react-hot-toast";
import config from "../config.json";
import AuthService from "./authService";
import { Loading } from "../components/common/loading";

export default class ApiServices {
  static classInstance: ApiServices;
  static getInstance() {
    if (!ApiServices.classInstance) {
      ApiServices.classInstance = new ApiServices();
    }
    return this.classInstance;
  }
  spinCounter: number = 0;

  async makeRequest(
    path: string,
    method: "GET" | "POST" | "PUT" | "DELETE" = "GET",
    body?: any
  ) {
    const url = config.API.URL + path;
    this.showSpinner();

    const result = Promise.resolve(AuthService.getInstance().getIdToken()).then(
      (idToken) => {
        // console.log("id token",idToken)
        let idTok = idToken;
        return fetch(url, {
          method: method,
          headers: { "x-auth-id": idTok, "Content-Type": "application/json" },
          body: JSON.stringify(body),
        })
          .then((res) => res.json())
          .then((data) => {
            this.hideSpinner();
            return data;
          })
          .catch((err) => {
            this.hideSpinner();
            console.error(err);
          });
      }
    );
    return result;
  }

  async makeRequestWithoutSpinner(
    path: string,
    method: "GET" | "POST" | "PUT" | "DELETE" = "GET",
    body?: any
  ) {
    const url = config.API.URL + path;

    const result = Promise.resolve(AuthService.getInstance().getIdToken()).then(
      (idToken) => {
        let idTok = idToken;
        return fetch(url, {
          method: method,
          headers: { "x-auth-id": idTok, "Content-Type": "application/json" },
          body: JSON.stringify(body),
        })
          .then((res) => res.json())
          .then((data) => {
            return data;
          })
          .catch((err) => {
            console.error(err);
          });
      }
    );
    return result;
  }

  showSpinner() {
    this.spinCounter++;
    if (this.spinCounter === 1) {
      toast.custom(<Loading />, { duration: Infinity });
    }
  }

  hideSpinner() {
    this.spinCounter--;
    if (this.spinCounter === 0) {
      toast.remove();
    }
  }
}
